import { useEffect } from "react";
import { createPortal } from "react-dom";
import { getAppPortalRoot } from "../utils/appPortal";
import { X } from "lucide-react";
import "./DeleteWordModal.css";
import "./SuccessEwssFilterModal.css";

export const SUCCESS_EWSS_FILTERS = {
  ALL: "all",
  WITH_EWSS: "withEwss",
  WITHOUT_EWSS: "withoutEwss",
};

const OPTIONS = [
  {
    value: SUCCESS_EWSS_FILTERS.ALL,
    label: "Tous les mots correctement restitués",
    hint: "Affichage par défaut",
  },
  {
    value: SUCCESS_EWSS_FILTERS.WITH_EWSS,
    label: "Mots avec un score EWSS uniquement",
    hint: "Au moins 3 apparitions en jeu et note calculée",
  },
  {
    value: SUCCESS_EWSS_FILTERS.WITHOUT_EWSS,
    label: "Mots sans score EWSS",
    hint: "Restitués correctement mais EWSS indisponible",
  },
];

export default function SuccessEwssFilterModal({ open, value, onChange, onClose }) {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  const handleSelect = (nextValue) => {
    onChange?.(nextValue);
    onClose?.();
  };

  return createPortal(
    <div
      className="delete-word-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div
        className="delete-word-modal success-ewss-filter-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-ewss-filter-modal-title"
      >
        <button
          type="button"
          className="delete-word-modal__close"
          onClick={onClose}
          aria-label="Fermer"
        >
          <X size={18} strokeWidth={2.5} />
        </button>

        <h3
          id="success-ewss-filter-modal-title"
          className="success-ewss-filter-modal__title"
        >
          Filtrer les mots restitués
        </h3>
        <p className="delete-word-modal__text">
          Choisissez quels mots afficher parmi ceux correctement restitués à leur
          dernière apparition en jeu.
        </p>

        <div
          className="success-ewss-filter-modal__options"
          role="radiogroup"
          aria-label="Filtre EWSS"
        >
          {OPTIONS.map((option) => (
            <label key={option.value} className="success-ewss-filter-modal__option">
              <input
                type="radio"
                name="success-ewss-filter"
                className="success-ewss-filter-modal__radio"
                checked={value === option.value}
                onChange={() => handleSelect(option.value)}
              />
              <span className="success-ewss-filter-modal__option-body">
                <span className="success-ewss-filter-modal__option-label">
                  {option.label}
                </span>
                <span className="success-ewss-filter-modal__option-hint">
                  {option.hint}
                </span>
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>,
    getAppPortalRoot()
  );
}
